// frontend/modules/customer-loan-info/routes.tsx
import * as React from 'react';
import { RouteObject } from 'react-router-dom';
import { CustomerLoanInfoView } from './views/CustomerLoanInfoView';
import { ErrorBoundary } from "@/shared/components/ErrorBoundary";

export const customerLoanInfoRoutes: RouteObject[] = [
    {
        path: '/loans/customer-info',
        element: <CustomerLoanInfoView />,
        errorElement: <ErrorBoundary />
    }
];
